<template>
  <div class="mainContainer">
    <div v-if="categoryMenu.length > 0"
         class="mainContainer-container">
      <a-input-search v-model:value="searchDesginer"
                      :placeholder="$t('DesignShare.DssCategoriesPage.placeholder')"  
                      class="input-search"
                      @search="getCategoryDetail(activeIndex, materialTagSelected)"
                      @press-enter="getCategoryDetail(activeIndex, materialTagSelected)" />
      <div class="mainContainer-container-leftBox">
        <a-menu v-model:selectedKeys="categoryMenusSelectedKeys"
                mode="horizontal"
                class="menu"
                @click="menusClick">
          <a-menu-item v-for="(item, index) in categoryMenu"
                       :id="String(item.id)"
                       :key="item.id"
                       :index="index"
                       :name="item.name"
                       :class="activeIndex == item.id ? 'activeItem' : ''">
            {{ item.name }}
          </a-menu-item>
        </a-menu>
        <a-menu v-model:selectedKeys="materialTagSelectedKeys"
                mode="horizontal"
                :multiple="true"
                class="material-tag-menu"
                @select="materialTagMenusSelect"
                @deselect="materialTagMenusDeselect">
          <a-menu-item v-for="(item, index) in tagsList"
                       :id="String(item.id)"
                       :key="item.id"
                       :index="index"
                       :name="item.name"
                       :class="activeIndex == item.id ? 'activeItem' : ''">
            {{ item.name }}
          </a-menu-item>
        </a-menu>
      </div>
      <div></div>
      <div class="mainContainer-container-rightBox">
        <div class="mainContainer-container-rightBox-content">
          <Card v-for="(item, index) in categoryArray"
                :key="index"
                :theme="item"
                :is-home="props.isHome" />
          <a-empty v-if="categoryArray.length == 0 && !spinState"></a-empty>
        </div>
      </div>
      <div class="footer">
        <APagination v-model:current="pagination.current"
                     v-model:pageSize="pagination.pageSize"
                     :show-size-changer="true"
                     :total="pagination.total"
                     @change="handleTableChange" />
      </div>
    </div>
    <a-empty v-else></a-empty>
  </div>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref, watch } from "vue"
import { useRoute } from "vue-router"
import { APagination } from '@iota-cn/ui-components'
import { categoriesDssDetail, categoriesTypeMenu, fetchMaterialTag } from "../api"
import type { categoriesDetailState, categoriesMenusState, MaterialTag, Reference, CustomSpu, ProdcutDesginShareTheme } from "../configure"
import { message } from 'ant-design-vue'
import Card from "./DssCategoriesCardPage.vue"
const route = useRoute()
const tagsList = ref<MaterialTag[]>([])
const materialTagSelectedKeys = ref<string[]>([])
const materialTagSelected = ref<string>('')
const searchDesginer = ref<string>('')
// initialize Startup
onMounted(() => {
  init()
})
const props = defineProps<{
  isHome: boolean
}>()
const init = async () => {
  const selectId = route.query.id
  await getCategoryMenus().then((id) => {
    if (selectId) {
      activeIndex.value = selectId
      getCategoryDetail(selectId as string)
    } else if (id !== null && id !== undefined) {
      activeIndex.value = id
      getCategoryDetail(id as string)
    }
    categoryMenusSelectedKeys.value = []
    categoryMenusSelectedKeys.value.push(activeIndex.value)
  })
  await fetchMaterialTag().then((res) => {
    tagsList.value = res.data.items
  }).catch(() => {
    message.error('基础数据加载错误，系统可能在维护，请稍后重试。')
  })
}

// declare Type
const menusId = ref<string>('')
const categoryMenu = reactive<categoriesMenusState["categories"]>([])
const categoryMenusSelectedKeys = ref<number[]>([])
const spinState = ref<boolean>(false)
const categoryMenuText = ref<string>()
const categoryArray = reactive<Array<categoriesDetailState>>([])
const activeIndex = ref()
const pagination = ref({
  current: 1,
  total: 0,
  offset: 0,
  pageSize: 20,
  showSizeChanger: true,
  pageSizeOptions: ['20', '40', '60', '80'], // 每页中显示的数据
  showTotal: (total: number) => `共有 ${total} 条`, // 分页中显示总的数据
  size: 'small',
})

const initPagination = () => {
  pagination.value.offset = 0
  pagination.value.pageSize = 20
  pagination.value.total = 0
}

const handleTableChange = (current: number, pageSize: number) => {
  pagination.value.current = current
  pagination.value.offset = (current - 1) * pageSize
  getCategoryDetail(activeIndex.value, materialTagSelected.value)
}

const materialTagMenusSelect = (menusItem: { item: { id: string; name: string } }) => {
  initPagination()
  if (materialTagSelected.value.length)
    materialTagSelected.value += ','
  materialTagSelected.value += menusItem.item.name
  getCategoryDetail(activeIndex.value, materialTagSelected.value)
}

const materialTagMenusDeselect = (menusItem: { item: { id: string; name: string } }) => {
  materialTagSelected.value = materialTagSelected.value.replace(new RegExp(`,${menusItem.item.name}?|${menusItem.item.name},?`, "g"), "")
  getCategoryDetail(activeIndex.value, materialTagSelected.value)
}

// declare Function
const menusClick = (menusItem: { item: { id: string; name: string } }) => {
  initPagination()
  const { name, id } = menusItem.item
  categoryMenuText.value = name
  activeIndex.value = id
  getCategoryDetail(id)
}

// declare Method
const getCategoryMenus = (): Promise<string | number> => {
  return new Promise((resolve, reject) => {
    categoriesTypeMenu().then((result) => {
      const { categories } = result
      categoryMenu.length = 0
      categoryMenu.push(...categories)
      if (categoryMenu.length > 0) {
        categoryMenuText.value = categoryMenu.find((item) => item.id === menusId.value)?.name || categoryMenu[0].name
        categoryMenusSelectedKeys.value.push((Number(menusId.value) as number) || (categoryMenu[0].id as number))
        resolve(menusId.value || categoryMenu[0].id)
      }
    })
  })
}
const getCategoryDetail = (id: string, tags?: string): void => {
  spinState.value = true
  categoryArray.length = 0
  const data: {
    offset: number
    limit: number
    tags?: string
    designer?: string
  } = { offset: pagination.value.offset, limit: pagination.value.pageSize }
  if (tags) {
    data.tags = tags
  }
  if (searchDesginer.value) {
    data.designer = searchDesginer.value
  }
  categoriesDssDetail(id, data).then((result: any) => {
    confirmRightofUse(result.rows)
    categoryArray.push(...result.rows)
    pagination.value.total = result.count
    spinState.value = false
  })
  menusId.value = id
}

const confirmRightofUse = (result: ProdcutDesginShareTheme[]) => {
  result.forEach((res: ProdcutDesginShareTheme) => {
    // 会按照当前账户的id检索 正常只dssOrder会有一条所以使用下标0  
    // type 0代表购买了整体使用权 status 1是已付款 2 是已锁单
    // free 代表该设计当前免费 也进行处理
    if (res.free || (res.dssOrders && res.dssOrders.length && res.dssOrders[0].type == 0 && (res.dssOrders[0].status == 1 || res.dssOrders[0].status == 2))) {
      res.customSpus.forEach((r: CustomSpu) => {
        r.references.forEach((j: Reference) => {
          j.type = '0'
        })
      })
    }
  })
}
watch(
  () => route.query,
  () => {
    init()
  },
  { deep: true }
)
</script>

<style lang="less" scoped>
.mainContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;

  .footer {
    margin-right: 10px;
  }

  .input-search {
    width: 300px;
    margin-top: 10px;
    margin-right: 10px;
  }

  &-container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;

    &-leftBox {
      width: 100%;
      padding: 10px 0;
      overflow: hidden;
      overflow-y: auto;

      .ant-menu-horizontal {
        border-bottom: none;
      }

      .menu {
        :deep(.ant-menu-item-selected) {
          background: #111111 !important;
          color: #ffffff;
        }

        :deep(.ant-menu-item-active) {
          border: 1px solid #111111 !important;
        }

        :deep(.ant-menu-item-selected::after) {
          border: 1px solid #111111 !important;
        }

        :deep(.ant-menu-item-active::after) {
          border: 1px solid #111111 !important;
          display: none;
        }

        :deep(.ant-menu-item) {
          margin: 5px 5px 5px 5px;
          border: 1px solid #f1f1f1;
          width: 98px;
          text-align: center;
        }

        :deep(.ant-menu-item:first-child) {
          margin-left: 25px;
        }
      }

      .material-tag-menu {
        color: #999999;
        margin-left: 10px;

        :deep(.ant-menu-item-selected) {
          color: black !important;
        }

        :deep(.ant-menu-item-selected::after) {
          border: none !important;
        }

        :deep(.ant-menu-item) {
          padding-left: 10px;
          padding-right: 10px;
          width: 70px;
          text-align: center;
        }
      }
    }

    &-rightBox {
      flex: 1;
      width: 100%;
      overflow: hidden;
      overflow-y: auto;

      &-title {
        width: 100%;
        height: 40px;

        &-text {
          font-size: 20px;
          margin-left: 20px;
          margin-top: 5px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 28px;
        }
      }

      &-content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        align-items: center;

        .ant-empty {
          margin-top: 30px;
        }

        .ant-spin {
          margin-top: 50px;
        }
      }
    }
  }
}

:deep(.ant-spin-container) {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
}

:deep(.ant-menu-item-selected) {
  background-color: #fff !important;
}

:deep(.activeItem) {
  background-color: #111111 !important;
  color: #ffffff;
}
</style>
